var _rect, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgJoiningDate(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#F1FBFB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.3333 11.6667V15M16.6667 11.6667V15",
    stroke: "#003E3E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8333 13.3333H19.1667C16.024 13.3333 14.4526 13.3333 13.4763 14.3097C12.5 15.286 12.5 16.8573 12.5 20V21.6667C12.5 24.8093 12.5 26.3808 13.4763 27.357C14.4526 28.3333 16.024 28.3333 19.1667 28.3333H20.8333C23.976 28.3333 25.5474 28.3333 26.5237 27.357C27.5 26.3808 27.5 24.8093 27.5 21.6667V20C27.5 16.8573 27.5 15.286 26.5237 14.3097C25.5474 13.3333 23.976 13.3333 20.8333 13.3333Z",
    stroke: "#003E3E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 18.3333H27.5",
    stroke: "#003E3E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJoiningDate);
export default __webpack_public_path__ + "static/media/Joining_date.ba9d80ce166d2e9c095e4dd2d9fdbd20.svg";
export { ForwardRef as ReactComponent };